import * as ActionType from "../actionType";
import { fetchPostApi } from "../../services/page/post";

const getPostAction = () => {
  return async dispatch => {
    dispatchPost(dispatch);
  };
};

const dispatchPost = dispatch => {
  fetchPostApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_POST,
      data
    });
  });
};

export { getPostAction, dispatchPost };



// WEBPACK FOOTER //
// ./src/actions/page/post.js